/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';

export const FirstTimersGuidePaForm = () => (
  <>
    <h2>Unforgettable Experiences</h2>
    <a
      className="btn"
      href="https://shop.woodwardpa.com/Registration/EventSelection/3/?filter=Locations%7C6^EventTypes%7C7%7C1012"
    >
      BOOK NOW
    </a>
  </>
);

FirstTimersGuidePaForm.propTypes = {};
